<script setup>

const toastClassMap = {
  success: 'tw-text-success-900 tw-border-success tw-bg-success-100',
  info: 'tw-text-info-900 tw-border-info tw-bg-info-100',
  warning: 'tw-text-caution-900 tw-border-caution tw-bg-caution-100',
  error: 'tw-text-danger-700 tw-border-danger tw-bg-danger-100',
}

const toastIconMap = {
  success: 'icons/tick-in-circle',
  info: 'icons/info-in-square',
  warning: 'icons/warning-circle',
  error: 'icons/error-circle',
}

defineProps({
  toast: {
    type: Object,
    required: true,
  },
})
const emit = defineEmits(['dismiss'])
</script>

<template>
  <div
    class="tw-flex tw-w-[512px] tw-z-[9999] tw-items-center tw-border tw-border-l-8 tw-rounded-lg tw-py-7 tw-px-8 tw-gap-x-10 tw-left-0 tw-right-0 tw-cursor-pointer"
    :class="toastClassMap[toast.status]"
  >
    <SvgVue
      icon="icons/cross"
      class="tw-w-4 tw-h-4 tw-text-slate-3 tw-cursor-pointer tw-absolute tw-top-1.5 tw-right-1.5"
      @click="emit('dismiss')"
    />
    <div class="tw-p-3 tw-flex tw-bg-white tw-rounded-xl">
      <SvgVue
        :icon="toastIconMap[toast.status]"
        class="tw-w-8 tw-h-8"
      />
    </div>

    <div class="tw-flex tw-flex-col tw-gap-y-2">
      <span class="tw-text-base tw-font-bold">{{ toast.title }}</span>
      <span class="tw-text-sm tw-no-underline">
        {{ toast.text }}
      </span>
    </div>
  </div>
</template>

